import { render, staticRenderFns } from "./CoachDetailReviewSummary.vue?vue&type=template&id=b14b2004&scoped=true&lang=pug"
import script from "./CoachDetailReviewSummary.vue?vue&type=script&lang=js"
export * from "./CoachDetailReviewSummary.vue?vue&type=script&lang=js"
import style0 from "./CoachDetailReviewSummary.vue?vue&type=style&index=0&id=b14b2004&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14b2004",
  null
  
)

export default component.exports